<template>
  <div v-if="contextData">
    <SectionTabHorizLogo02
      v-if="contextData.type === 'cases-logo'"
      :title="contextData.title"
      :description="contextData.description"
      :tabs="contextLogoTabs"
    />
    <SectionCard07CarouselResource03
      v-else
      :title="contextData.title"
      :description="contextData.description"
      :items="contextCaseItems"
    />
  </div>
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface ISuccessfulCaseData {
    title: string;
    description?: string;
    type: 'cases-logo' | 'cases';
    tabs: {
      tabName: string;
      name: string;
      description?: string;
      link: string;
      thumbnail: string;
      trackingCode?: string;
      tag?: string;
      logo?: string;
      authorName?: string;
      authorJobTitle?: string;
      authorCompany?: string;
    }[];
  }

  interface ISuccessfulCase {
    component: 'successful-case';
    meta: {
      navigable?: string;
    };
    data: ISuccessfulCaseData;
  }

  type IProps = ISuiteProps<ISuccessfulCase>;

  const props = defineProps<IProps>();

  const { provideFormatUrl } = useFormatUrl();
  const { provideSuiteThumbnailUrl, provideSuiteLogoUrl } = useImagePath(
    props.urlConnector
  );

  const contextData = computed((): ISuccessfulCaseData => props.suiteData.data);

  const contextLogoTabs = computed((): ISuccessfulCaseData['tabs'] =>
    contextData.value.tabs.map((item) => ({
      ...item,
      link: provideFormatUrl(item.link),
      thumbnail: provideSuiteThumbnailUrl(item.thumbnail),
      logo: provideSuiteLogoUrl(item.logo || ''),
    }))
  );

  const contextCaseItems = computed((): ISuccessfulCaseData['tabs'] =>
    contextData.value.tabs.map((item) => ({
      ...item,
      link: provideFormatUrl(item.link),
      thumbnail: provideSuiteThumbnailUrl(item.thumbnail),
    }))
  );

  export type { ISuccessfulCase, ISuccessfulCaseData };
</script>
